interface HistoryIconsProps {
  icon: 'car' | 'plane' | 'clover' | 'no icon';
}

export const HistoryIcons = ({ icon }: HistoryIconsProps) => {
  switch (icon) {
    case 'car':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M19 20H5V21C5 21.2652 4.89464 21.5196 4.70711 21.7071C4.51957 21.8946 4.26522 22 4 22H3C2.73478 22 2.48043 21.8946 2.29289 21.7071C2.10536 21.5196 2 21.2652 2 21V12L4.513 5.298C4.65593 4.91669 4.91186 4.5881 5.24656 4.35615C5.58126 4.1242 5.97878 3.99995 6.386 4H17.614C18.0212 3.99995 18.4187 4.1242 18.7534 4.35615C19.0881 4.5881 19.3441 4.91669 19.487 5.298L22 12V21C22 21.2652 21.8946 21.5196 21.7071 21.7071C21.5196 21.8946 21.2652 22 21 22H20C19.7348 22 19.4804 21.8946 19.2929 21.7071C19.1054 21.5196 19 21.2652 19 21V20ZM4.136 12H19.864L17.614 6H6.386L4.136 12ZM6.5 17C6.89782 17 7.27936 16.842 7.56066 16.5607C7.84196 16.2794 8 15.8978 8 15.5C8 15.1022 7.84196 14.7206 7.56066 14.4393C7.27936 14.158 6.89782 14 6.5 14C6.10218 14 5.72064 14.158 5.43934 14.4393C5.15804 14.7206 5 15.1022 5 15.5C5 15.8978 5.15804 16.2794 5.43934 16.5607C5.72064 16.842 6.10218 17 6.5 17ZM17.5 17C17.8978 17 18.2794 16.842 18.5607 16.5607C18.842 16.2794 19 15.8978 19 15.5C19 15.1022 18.842 14.7206 18.5607 14.4393C18.2794 14.158 17.8978 14 17.5 14C17.1022 14 16.7206 14.158 16.4393 14.4393C16.158 14.7206 16 15.1022 16 15.5C16 15.8978 16.158 16.2794 16.4393 16.5607C16.7206 16.842 17.1022 17 17.5 17Z"
            fill="white"
          />
        </svg>
      );

    case 'clover':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clipPath="url(#clip0_1385_9009)">
            <path
              d="M6.75 2.5C7.30812 2.5 7.86077 2.60993 8.37641 2.82351C8.89204 3.03709 9.36056 3.35015 9.75521 3.7448C10.1499 4.13945 10.4629 4.60796 10.6765 5.1236C10.8901 5.63923 11 6.19188 11 6.75V11H6.75C5.62283 11 4.54183 10.5522 3.7448 9.7552C2.94777 8.95817 2.5 7.87717 2.5 6.75C2.5 5.62283 2.94777 4.54183 3.7448 3.7448C4.54183 2.94777 5.62283 2.5 6.75 2.5ZM6.75 13H11V17.25C11 18.0906 10.7507 18.9123 10.2837 19.6112C9.81675 20.3101 9.15299 20.8548 8.37641 21.1765C7.59982 21.4982 6.74529 21.5823 5.92087 21.4183C5.09645 21.2543 4.33917 20.8496 3.7448 20.2552C3.15042 19.6608 2.74565 18.9036 2.58166 18.0791C2.41768 17.2547 2.50184 16.4002 2.82351 15.6236C3.14519 14.847 3.68992 14.1833 4.38883 13.7163C5.08774 13.2493 5.90943 13 6.75 13ZM17.25 2.5C18.3772 2.5 19.4582 2.94777 20.2552 3.7448C21.0522 4.54183 21.5 5.62283 21.5 6.75C21.5 7.87717 21.0522 8.95817 20.2552 9.7552C19.4582 10.5522 18.3772 11 17.25 11H13V6.75C13 5.62283 13.4478 4.54183 14.2448 3.7448C15.0418 2.94777 16.1228 2.5 17.25 2.5ZM13 13H17.25C18.0906 13 18.9123 13.2493 19.6112 13.7163C20.3101 14.1833 20.8548 14.847 21.1765 15.6236C21.4982 16.4002 21.5823 17.2547 21.4183 18.0791C21.2544 18.9036 20.8496 19.6608 20.2552 20.2552C19.6608 20.8496 18.9036 21.2543 18.0791 21.4183C17.2547 21.5823 16.4002 21.4982 15.6236 21.1765C14.847 20.8548 14.1833 20.3101 13.7163 19.6112C13.2493 18.9123 13 18.0906 13 17.25V13Z"
              fill="#03292E"
            />
          </g>
          <defs>
            <clipPath id="clip0_1385_9009">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'plane':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M14 8.947L22 14V16L14 13.474V18.834L17 20.5V22L12.5 21L8 22V20.5L11 18.833V13.473L3 16V14L11 8.947V3.5C11 3.10218 11.158 2.72064 11.4393 2.43934C11.7206 2.15804 12.1022 2 12.5 2C12.8978 2 13.2794 2.15804 13.5607 2.43934C13.842 2.72064 14 3.10218 14 3.5V8.947Z"
            fill="white"
          />
        </svg>
      );
    case 'no icon':
      return null;
    default:
      return null;
  }
};
